export default class pegTurnstile extends HTMLElement {
	connectedCallback() {
		this.sitekey = this.getAttribute('sitekey');
		this.isInteractiveChallenge = false;
		this.turnstileContainer = this.querySelector('.turnstile-container');
		this.errorMessage = this.querySelector('#regTurnstileError');

		this.#loadTurnstileScript();
	}

	#loadTurnstileScript() {
		const script = document.createElement('script');
		script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
		script.defer = true;
		script.onload = () => this.#renderTurnstile();

		this.append(script);
	}

	#renderTurnstile() {
		turnstile.render(this.turnstileContainer, {
			'sitekey': this.sitekey,
			'size': 'flexible',
			'retry': 'never',
			'appearance': 'interaction-only',
			'callback': () => this.#successCallback(),
			'error-callback': (error) => this.#errorCallback(error),
			'before-interactive-callback': () => this.#beforeInteractiveCallback(),
			'language': document.documentElement.lang.toLowerCase(),
		});
	}

	#successCallback() {
		jPar.wdk.forms.hideError(this.errorMessage);
	}

	#errorCallback(error) {
		jPar.util.log.bigData({
			category: 'registration',
			subcategory: 'registration_start_screen',
			action: 'turnstile_error',
			targetId: 'turnstile_error',
			cd1: error,
			cd2: this.sitekey,
		});
	}

	#beforeInteractiveCallback() {
		this.setAttribute('is-interactive-challenge', '');
		this.isInteractiveChallenge = true;
	}

	validate() {
		const isValid = turnstile?.getResponse(this.turnstileContainer) !== undefined;

		if (!isValid && this.isInteractiveChallenge) {
			jPar.wdk.forms.showError(this.errorMessage);
		}

		return isValid;
	}
}
